import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { BASE_URL } from './../../Api/ApiUrls';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Card,
  CardContent,
  CircularProgress,
  Avatar
} from '@mui/material';
import FormsBottomNavbar from "./../Post Module/FormsBottomNavbar";
import VisibilityIcon from '@mui/icons-material/Visibility';

function ViewListPage() {
  const { propertyId } = useParams();
  const [viewers, setViewers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [propertyDetails, setPropertyDetails] = useState(null);
  const navigate = useNavigate();

  const maskPhoneNumber = (phone) => {
    if (!phone) return "N/A";
    const lastThree = phone.slice(-3); 
    return `XXX XXXX ${lastThree}`;
  };

  useEffect(() => {
    const fetchViewers = async () => {
      try {
        // Fetch property details first
        const propertyResponse = await axios.get(`${BASE_URL}/property/`);
        const property = propertyResponse.data.find(
          item => item.property_id == propertyId
        );
        setPropertyDetails(property);

        // Fetch all activities
        const response = await axios.get(`${BASE_URL}/activities/`);
        
        // Filter activities for this property with "Description" type
        const propertyViews = response.data.filter(activity => 
          activity.property_id == propertyId && 
          activity.activity_type === "Description"
        );
        
        // Get user details for each viewer
        const viewersWithDetails = await Promise.all(
          propertyViews.map(async (view) => {
            try {
              const userResponse = await axios.get(`${BASE_URL}/users/${view.user_id}/`);
              return {
                ...view,
                userDetails: userResponse.data
              };
            } catch (error) {
              console.error(`Error fetching user ${view.user_id}:`, error);
              return {
                ...view,
                userDetails: { username: "Unknown User" }
              };
            }
          })
        );
        
        setViewers(viewersWithDetails);
      } catch (error) {
        console.error('Error fetching viewers:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchViewers();
  }, [propertyId]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        background: `
          linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
          url('/construction4.png')
        `,
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <AppBar 
        position="static" 
        elevation={0}
        sx={{ 
          background: `
            linear-gradient(145deg,rgb(22, 22, 22),rgb(15, 15, 15)),
            url('/construction5.png')
          `,
          color: 'text.primary',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}
      >
        <Toolbar sx={{ minHeight: 64 }}>
          <IconButton 
            edge="start" 
            onClick={() => navigate(-1)}
            sx={{ 
              color: '#ffffff',
              backgroundColor: 'rgba(255,255,255,0.1)',
              '&:hover': { 
                backgroundColor: 'rgba(255,255,255,0.2)' 
              }
            }}
          >
            <ArrowBackIosNewIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1, ml: 2, color: 'white', fontSize: { xs: '0.8rem', sm: '1.25rem' } }}>
            Property ID: {propertyId} Viewers
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Main Content - Scrollable Area */}
      <Container 
        sx={{ 
          py: 3,
          flex: 1,
          overflow: 'auto',
          mb: 7
        }}
      >
        <Card sx={{ borderRadius: '12px', overflow: 'hidden', boxShadow: 3 }}>
          <Typography
            variant="h6"
            align="center"
            sx={{ 
              p: 2, 
              backgroundColor: '#f5f5f5', 
              fontWeight: 'bold',
              fontSize: { xs: '0.8rem', sm: '1.25rem' }
            }}
          >
            Property Viewers
          </Typography>

          <CardContent>
            {viewers.length > 0 ? (
              <Box display="flex" flexDirection="column" gap={2}>
                {viewers.map((view, index) => (
                  <Card
                    key={view.log_id || index}
                    sx={{
                      p: 2,
                      borderRadius: 3,
                      boxShadow: 2,
                      backgroundColor: '#fff',
                    }}
                  >
                    <Box display="flex" justifyContent="flex-end" alignItems="center">
                      <Box
                        sx={{
                          backgroundColor: '#e3f2fd',
                          color: '#1565c0',
                          px: 1.5,
                          py: 0.5,
                          borderRadius: 2,
                          fontSize: '10px',
                          fontWeight: 500,
                          display: 'inline-block'
                        }}
                      >
                        Viewed Property
                      </Box>
                    </Box>

                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      <Box display="flex" alignItems="center">
                        <Avatar 
                          sx={{ 
                            bgcolor: '#1976d2', 
                            mr: 2,
                            width: 40, 
                            height: 40 
                          }}
                        >
                          {view.userDetails?.username?.charAt(0)?.toUpperCase() || 'U'}
                        </Avatar>
                        <Box>
                          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '0.8rem' }}>
                            {view.userDetails?.username || "Unknown User"}
                          </Typography>

                          <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                            CUSTOMER: {String(view.user_id).padStart(4, "0")}
                          </Typography>

                          {view.userDetails?.mobile_no && (
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                              PHONE: {maskPhoneNumber(view.userDetails.mobile_no)}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Card>
                ))}
              </Box>
            ) : (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <VisibilityIcon sx={{ fontSize: 60, color: '#bdbdbd', mb: 2 }} />
                <Typography variant="h6" color="text.secondary" sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                  No users have viewed this property yet
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1, fontSize: '0.875rem' }}>
                  When users view your property, they will appear here.
                </Typography>
              </Box>
            )}
          </CardContent>
        </Card>
      </Container>

      {/* Bottom Navigation */}
      <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}>
        <FormsBottomNavbar /> 
      </Box>
    </Box>
  );
}

export default ViewListPage;